// extracted by mini-css-extract-plugin
export default {"inputContainer":"TextExercise_inputContainer__hkuXV","inputArea":"TextExercise_inputArea__FaJ1f","characterCounter":"TextExercise_characterCounter__Uy6lS"};